import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import { BaseError } from '@utils/types/shared/base.ts';
import { Axios } from '@utils/api/axios-instance.ts';
import { PUT_URL } from '@utils/api/endpoints.ts';

export const useDeactivateResellerCustomerLogin = (
  customerId: number,
  userId: number
) => {
  const deactivateResellerCustomerLogin = async () => {
    await Axios.put(
      PUT_URL(customerId.toString(), userId.toString())
        .deactivateResellerCustomerLogin
    );
  };

  return useMutation<void, AxiosError<BaseError>>(
    deactivateResellerCustomerLogin
  );
};
